module.exports = __webpack_public_path__ + "static/media/logo.ec73cfa4.jpg";